import { apiHelper } from '@/utils'
import { API } from '@/constants'
import { sharedHelper } from '@/utils';

export const configurationService = {
  getAllConfiguration,
  getConfiguration,
  updateConfiguration
};

const MODULE = {
  CONFIGURATION: 'configurations',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'

export function getAllConfiguration(filter) {

  const requestOptions = {
    params: {
      page: filter.pageNumber,
      size: filter.pageSize,
      is_locked: filter.isLocked,
      is_active: filter.isActive
    }
  }

  let arr = filter.searchArray
  arr.forEach((word, index) => {
    if (word != null || word != '') {
      var searchParam = `search_words[${index}]`
      requestOptions.params[searchParam] = word
    }
  })

  return apiHelper(API_URL).get(`/${MODULE.CONFIGURATION}`, requestOptions)
}

export function getConfiguration(key) {
  return apiHelper(API_URL).get(`/${MODULE.CONFIGURATION}/${key}`)
}

export function updateConfiguration(data) {

  if (data.valueType != 'image' && data.valueType != 'imageArray') {
    const requestOptions = {
      key: data.key,
      value: data.value
    }

    return apiHelper(API_URL).put(`/${MODULE.CONFIGURATION}/${data.key}`, requestOptions)
  }
  else {
    const formData = new FormData();
    formData.append('_method', "put");
    sharedHelper.appendIfNotNull(formData, 'key', data.key);

    if (data.valueType == 'image') {
      if (data.value instanceof File) {
        formData.append('value', data.value);
      }

    }
    else {
      console.log('empty value type');
    }

    return apiHelper(API_URL).post(`/${MODULE.CONFIGURATION}/${data.key}`, formData)
  }
}